import * as React from 'react'
import { connect } from 'react-redux'

import { playVideoPlayer, stopVideoPlayer } from '../actions/videoPlayer'

import { getActiveChannelId, getOverlayVisibility, getLatestVideoPlayerOperation } from '../reducers/gui'
import { getVideoOptions } from '../reducers/bookmakerOptions'
import { getPlayerclassAssetURL, getComponentContainer, getMobileStatus } from '../reducers/config'
import Livescore from './LiveScore';
import { setHeight } from '../actions/customerMethods';

declare let SRPlayer:any

let _player: any;

let channelRange = 4; // [0-7]
let videoHandler = "hls";

interface VideoAreaProps {
  stopVideoPlayer: () => void
  playVideoPlayer: () => void
  playerclassAssetURL: string
  videoset: any
  isMobile: boolean
  setHeight: any
  componentContainer: any
  activeChannelId: number
  latestVideoPlayerOperation: any
  overlayIsVisible: boolean
  children?: React.ReactNode
}

class VideoArea extends React.Component<VideoAreaProps, any> {
  busy:string;
  nextOperation:string;
  callbacks: object;

  constructor ( props: VideoAreaProps ) {
    super( props )
    this.state = {
      timeouts: new Array(),
    }

    // callbacks for the play button of the video player
    this.callbacks = {
       stopCallback : function(){ this.props.stopVideoPlayer() }.bind(this),
       playCallback : function(){ this.props.playVideoPlayer() }.bind(this)
    }
  }

  componentDidMount() {
    this.addPlayerClass();
  }

  // Adds the playerclass lib to the page and initiates the player
  addPlayerClass = () => {
      if (!_player) {
          const cdn = this.props.playerclassAssetURL;
          new Promise((resolve, reject) => {
              const script = document.createElement('script');
              document.head.appendChild(script);
              script.onload = resolve;
              script.onerror = reject;
              script.async = true;
              script.src = `${cdn}dist/player.lib.js`;
              script.classList.add('playerLibRef');
          }).then(() => {
              SRPlayer.PlayerManager.init({ init: this.initPlayer, cdn: cdn, playertype: SRPlayer.availablePlayerTypes.FLOWPLAYER7, mobileDemonstrator: this.props.isMobile, callbacks: this.callbacks}); // cdn true = default cdn, cdn false = relative URL, cdn string = absolute URL
          });
      } else {
          this.handlePlayerAction('');
      }
  }

  // Destroys the playerclass instance
  destroyPlayerClass = () => {
      if(_player) {
          _player.destroy();
          _player = null;

          //Delete all player.lib scripts from the head
          Array.from(document.querySelectorAll('.playerLibRef')).forEach((elem:any) => {
              document.head.removeChild(elem);
              elem = null;
          });

          // After the player is destroyed call an queued operation if one exists, if not, reset the queue
          if(this.nextOperation) {
              this.busy = this.nextOperation;
              this.nextOperation = null;
              this.handlePlayerAction(this.busy);
          } else {
              this.handlePlayerAction('');
          }
      } else {
          this.handlePlayerAction('');
      }
  }

  // Run the proper function for each action or reset the queue if there is no action
  handlePlayerAction = (action:String) => {
      switch (action) {
          case 'create':
              this.addPlayerClass();
              break;
          case 'destroy':
              this.destroyPlayerClass();
              break;
          default:
              this.busy = null;
              this.nextOperation = null;
      }
  }

  initPlayer = () => {
      const serverAndPort = this.props.videoset.serverName + this.props.videoset.serverApplicationUrl
      const setAndChannel = this.props.videoset.videoset + '_channel'

      const {setHeight, componentContainer} = this.props
      _player = new SRPlayer('playerContainer', {
              source: {
                  server: serverAndPort, /*'gfx-repaired/live/',//"retailvideo.aitcloud.de/live/",*/
                  set: setAndChannel, /*'VtiTest_channel',//"vflm_xb_sts-1280x720-adaptive_channel",*/
                  alt_server: '',//"vgvideozrh.aitcloud.de:80/live/",
                  alt_set: '' //"mp4:vflm_staging_srvg-640x360-vbr28-v1_channel"
              }, // obl.
              key: SRPlayer.PlayerManager.key,  // provide or auto-generate, String or array of String (Flowplayer)
              videoHandler: videoHandler,  // obligational.
              channelRange: channelRange,  // obligational, vflm 0-7, vfnc 0-3, basketball?
              channelStart: this.props.activeChannelId-1, // Get the active channel - 1 to get the id
              features: {
                  disableAudio: false,
                  disableFullscreen: true,
                  doNotReconnect: false,
                  reconnectInterval: 2000
              },
              muted: false,
              autoplay: !this.props.isMobile,
              mutedAutoplay: !this.props.isMobile,
              fullscreen: true,
              aspectRatio: '16:9',
              debug: {console: false, player: false},
              gui: {use: true, place: 'right'},  // Todo: position vfc-2711
              product: SRPlayer.availableProducts.VTI,  // TODO: Konstante analog getPlayerType vfc-3406 + estimation
              videoMode: "live"   // vod or live

          },
          SRPlayer.availablePlayerTypes.FLOWPLAYER7,
          () => {
              setHeight({
                  height: Math.ceil(componentContainer.getBoundingClientRect().height)
              })

              // After the player is created call an queued operation if one exists, if not, reset the queue
              if(this.nextOperation) {
                  this.busy = this.nextOperation;
                  this.nextOperation = null;
                  this.handlePlayerAction(this.busy);
              } else {
                  this.handlePlayerAction('');
              }
          }  //callback function
      );
  }

  componentWillReceiveProps ( newProps: VideoAreaProps ) {
    if(newProps.activeChannelId !== this.props.activeChannelId) {
      this.channelSwitch(newProps.activeChannelId - 1)
    }
    
    // Check if the destroy/create operation for the videoplayer has changed, and create a queue when necessary
    if(newProps.latestVideoPlayerOperation !== this.props.latestVideoPlayerOperation && this.busy) {
        this.nextOperation = newProps.latestVideoPlayerOperation;
    } else if(!this.busy && newProps.latestVideoPlayerOperation !== this.props.latestVideoPlayerOperation) {
        this.busy = newProps.latestVideoPlayerOperation;
        this.handlePlayerAction(newProps.latestVideoPlayerOperation);
    }
}

  channelSwitch(channel: number) {
    let hd = _player._anchor.getAttribute("data-status").indexOf("is-hd") > -1 ? true : false;

    // On mobile we need to set forceplay dynamically, depending on the video running or not
    let shouldVideoStart:boolean = true;
    let playButtonWrapper:any = _player._domElement.querySelector('#playButtonWrapper');
    if(playButtonWrapper) {
        shouldVideoStart = playButtonWrapper.classList.contains('hidden');
    }

    _player._domElement.dispatchEvent(
      new CustomEvent('Playerclass_channelSwitchEvent'+ _player._playerManagerId, {
        detail: {
          call    : 'channelSwitch', 
          channel : channel,
          hd      : hd,
          internal: false,
          forcePlay: shouldVideoStart
        }
      })
    );
  }

  render() {
      //console.log("render VideoArea");
    return (
        <div className="sr-cell VideoArea">
          <div className="sr-content">
              <div className={"video-area-live-score " + isOverlayVisible(this.props.overlayIsVisible)}>
                  <Livescore />
              </div>
            <div className="videoOverlayContent" style={{position: 'absolute'}}>
              {this.props.children}
            </div>
            <div className="wrapperWrapper">
              <div id="playerContainer"></div>
            </div>
          </div>
        </div>
    )
  }

}

// returns a stric hidden if the boolean is true
const isOverlayVisible = (visible : boolean) => visible ? 'hidden' : ''

const mapStateToProps = (state: any) => {

    return ({
        // get the score information for the active match
        activeChannelId: getActiveChannelId(state),
        videoset: getVideoOptions(state),
        playerclassAssetURL: getPlayerclassAssetURL(state),
        overlayIsVisible: getOverlayVisibility(state),
        componentContainer: getComponentContainer(state),
        latestVideoPlayerOperation: getLatestVideoPlayerOperation(state),
        isMobile: getMobileStatus(state)
    })
};

const mapDispatcherToProps = ( dispatch: Function ) => ({
  stopVideoPlayer: () => dispatch(stopVideoPlayer()),
  playVideoPlayer: () => dispatch(playVideoPlayer()),
  setHeight: (height: any) => dispatch(setHeight(height)),
})

export default connect(mapStateToProps, mapDispatcherToProps)(VideoArea)
